import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LOCALE, SUPPORTED_LOCALES, getSupportedLocale } from './locales';
import { applyDocumentLocale } from './browserTranslation';

import enCommon from './locales/en/common.json';
import enAssigneePortal from './locales/en/assigneePortal.json';
import enValidation from './locales/en/validation.json';
import hiCommon from './locales/hi/common.json';
import hiAssigneePortal from './locales/hi/assigneePortal.json';
import hiValidation from './locales/hi/validation.json';
import paCommon from './locales/pa/common.json';
import paAssigneePortal from './locales/pa/assigneePortal.json';
import paValidation from './locales/pa/validation.json';
import teCommon from './locales/te/common.json';
import teAssigneePortal from './locales/te/assigneePortal.json';
import teValidation from './locales/te/validation.json';
import orCommon from './locales/or/common.json';
import orAssigneePortal from './locales/or/assigneePortal.json';
import orValidation from './locales/or/validation.json';
import taCommon from './locales/ta/common.json';
import taAssigneePortal from './locales/ta/assigneePortal.json';
import taValidation from './locales/ta/validation.json';
import mrCommon from './locales/mr/common.json';
import mrAssigneePortal from './locales/mr/assigneePortal.json';
import mrValidation from './locales/mr/validation.json';
import bnCommon from './locales/bn/common.json';
import bnAssigneePortal from './locales/bn/assigneePortal.json';
import bnValidation from './locales/bn/validation.json';
import urCommon from './locales/ur/common.json';
import urAssigneePortal from './locales/ur/assigneePortal.json';
import urValidation from './locales/ur/validation.json';

export const defaultNS = 'common';

export const resources = {
  en: { common: enCommon, assigneePortal: enAssigneePortal, validation: enValidation },
  hi: { common: hiCommon, assigneePortal: hiAssigneePortal, validation: hiValidation },
  pa: { common: paCommon, assigneePortal: paAssigneePortal, validation: paValidation },
  te: { common: teCommon, assigneePortal: teAssigneePortal, validation: teValidation },
  or: { common: orCommon, assigneePortal: orAssigneePortal, validation: orValidation },
  ta: { common: taCommon, assigneePortal: taAssigneePortal, validation: taValidation },
  mr: { common: mrCommon, assigneePortal: mrAssigneePortal, validation: mrValidation },
  bn: { common: bnCommon, assigneePortal: bnAssigneePortal, validation: bnValidation },
  ur: { common: urCommon, assigneePortal: urAssigneePortal, validation: urValidation },
} as const;

i18n.on('languageChanged', (language) => {
  applyDocumentLocale(language);
});

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    defaultNS,
    ns: ['common', 'assigneePortal', 'validation'],
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: [...SUPPORTED_LOCALES],
    load: 'languageOnly',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lng',
      lookupLocalStorage: 'rentbhai_public_locale',
      caches: ['localStorage'],
      convertDetectedLanguage: (language: string) => getSupportedLocale(language),
    },
    react: {
      useSuspense: false,
    },
  })
  .then(() => {
    applyDocumentLocale(i18n.resolvedLanguage || i18n.language);
  });

export default i18n;
